import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'
import { CurrencySignType, I18nService, LgType } from '../../../services/prod/i18n.service'
import { GoodType } from '../bmcore-goods-block.component'

@Component({
  selector: 'bmcore-good-item',
  templateUrl: './bmcore-good-item.component.html',
  styleUrls: ['./bmcore-good-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreGoodItemComponent implements OnInit {
  @Input() good: GoodType

  lg: LgType
  currencySign: CurrencySignType

  constructor(private i18nService: I18nService) {}

  ngOnInit() {
    this.currencySign = this.i18nService.getCurrencySign()
    this.lg = this.i18nService.getLanguageForPage()
  }
}
